module.exports = __webpack_public_path__ + "static/Capital Factory Logo-bae4d8a39de5cd246710e8e0f3849295.png";